import { TopoConnection } from "../Topology/TopoConnection";
import { Link } from "../Core/Link";

export class LinkConnection extends TopoConnection
{
	constructor(
		public Link:Link){
		super();
	}
}
